import { useEffect } from 'react';

export const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(typeof to === 'function' ? to() : to);
  }, []);
};
